import {
  FiUser,
  FiBriefcase,
  FiDollarSign,
  FiFileText,
  FiCheckCircle,
} from "react-icons/fi";

const steps = [
  {
    label: "Basic",
    icon: FiUser,
  },
  {
    label: "Employment",
    icon: FiBriefcase,
  },
  {
    label: "Salary",
    icon: FiDollarSign,
  },
  {
    label: "Documents",
    icon: FiFileText,
  },
  {
    label: "Review",
    icon: FiCheckCircle,
  },
];

export default function EmployeeStepper({ currentStep }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 sticky top-8">
      <h2 className="text-xl font-bold text-gray-900">Employee Onboarding</h2>

      <p className="text-sm text-gray-500 mt-1">
        Complete all steps to add a new employee.
      </p>

      <div className="mt-8 space-y-4">
        {steps.map((step, index) => {
          const Icon = step.icon;

          const isCompleted = currentStep > index;
          const isActive = currentStep === index;

          return (
            <div key={step.label} className="flex items-start gap-4">
              <div
                className={`
                  h-12
                  w-12
                  rounded-xl
                  flex
                  items-center
                  justify-center
                  transition-all
                  ${
                    isCompleted
                      ? "bg-green-100 text-green-600"
                      : isActive
                        ? "bg-red-800 text-white"
                        : "bg-gray-100 text-gray-400"
                  }
                `}
              >
                <Icon size={20} />
              </div>

              <div className="pt-1">
                <p
                  className={`
                    font-medium
                    ${
                      isActive
                        ? "text-red-800"
                        : isCompleted
                          ? "text-gray-900"
                          : "text-gray-400"
                    }
                  `}
                >
                  Step {index + 1}
                </p>

                <p className="text-sm text-gray-500">{step.label}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
